<script setup>

import { inject, ref, watch } from 'vue';
import { normerNom, TypeNommage } from '@/scripts/global.js';
import { apiAjouterParametre } from '@/services/ServiceModele.js';
import { 
    getErreurNomNorme,
    getErreurTexteRequis, 
    getErreurValeurListeRequise } from '@/scripts/controlesSaisie.js';
import Dialog from 'primevue/dialog';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieTexte from '@/components/generiques/SaisieTexte.vue';
import SaisieTypeDonnee from '@/components/generiques/SaisieTypeDonnee.vue';

const { parametre, quandCree } = defineProps({
    parametre: Object,
    quandCree: Function
});

const visible = defineModel('visible', {
    type: Boolean
});

const getTypeDonnee = inject('getTypeDonnee');
const appelerApiModifModele = inject('appelerApiModifModele');

const nouveauParametre = ref(getParametreInitial());

watch(() => nouveauParametre.value.libelle, (nouveauLibelle, ancienLibelle) => {
    if (!nouveauParametre.value.nom || nouveauParametre.value.nom === normerNom(ancienLibelle, TypeNommage.VARIABLE)) {
        nouveauParametre.value.nom = normerNom(nouveauLibelle, TypeNommage.VARIABLE);
    }
});

function getParametreInitial() {
    return {
        nom: parametre.nom,
        libelle: parametre.libelle,
        typeDonnee: getTypeDonnee(parametre.typeDonnee),
        texteValeurCourante: null
    }
}

function validerSaisie(parametre) {
    const erreurs = {};
    erreurs.nom = getErreurNomNorme(parametre.nom, TypeNommage.VARIABLE);
    erreurs.libelle = getErreurTexteRequis(parametre.libelle);
    erreurs.typeDonnee = getErreurValeurListeRequise(parametre.typeDonnee);
    erreurs.texteValeurCourante = getErreurTexteRequis(parametre.texteValeurCourante);
    return erreurs;
}

function validerFormulaire() {
    nouveauParametre.value.validationFormulaire = true;
}

function ajouterParametre() {
	appelerApiModifModele(apiAjouterParametre, nouveauParametre.value, (reponseOK) => {
		if (reponseOK) {
            visible.value = false;
			if (quandCree) {
				quandCree.apply(null, [nouveauParametre.value.nom]);
			}
		}
	});
}

</script>

<template>
    <Dialog 
        v-model:visible="visible" 
        modal 
        header="Ajout d'un paramètre">
        <Formulaire
            :objet="nouveauParametre"
            :fonction-validation-saisie="validerSaisie"
            @validation="ajouterParametre">
            <label class="intitule">Libellé :</label>
            <SaisieTexte v-model:valeur="nouveauParametre.libelle" :id-erreur="'libelle'" :autofocus="true" />
            <label class="intitule">Nom :</label>
            <SaisieTexte v-model:valeur="nouveauParametre.nom" :id-erreur="'nom'" />
            <label class="intitule">Type :</label>
            <SaisieTypeDonnee v-model:valeur="nouveauParametre.typeDonnee" :id-erreur="'typeDonnee'"
                :proposer-types-objets="false" 
                :desactive="false" />
            <label class="intitule">Valeur courante :</label>
            <SaisieTexte v-model:valeur="nouveauParametre.texteValeurCourante" :id-erreur="'texteValeurCourante'" />
        </Formulaire>
            <template #footer>
                <button 
                    class="bouton fas fa-check" 
                    :disabled="false"
                    @click="validerFormulaire()"/>
            </template>
    </Dialog>
</template>

<style scoped>

</style>